import { convertStateToAbbr, getSnowLoss } from 'options';

const isLossObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

const shouldApplyStateSnow = (currentSnow, forceStateSnow) => {
  if (forceStateSnow) return true;
  if (currentSnow === undefined || currentSnow === null || currentSnow === '') {
    return true;
  }

  const numericSnow = Number(currentSnow);
  return Number.isFinite(numericSnow) && numericSnow === 0;
};

export const getStateSnowLoss = (state) => {
  if (!state || typeof state !== 'string') return null;

  const trimmed = state.trim();
  if (!trimmed) return null;

  const stateAbbr = /^[A-Za-z]{2}$/.test(trimmed) ? trimmed.toUpperCase() : convertStateToAbbr(trimmed, 'abbr');

  return stateAbbr ? getSnowLoss(stateAbbr) : null;
};

export const buildEffectiveSystemLosses = ({
  baseLosses = null,
  canvasLosses = null,
  iframeLosses = null,
  lead = null,
  forceStateSnow = false,
} = {}) => {
  const effectiveLosses = {};

  [baseLosses, canvasLosses, iframeLosses].forEach((losses) => {
    if (isLossObject(losses)) {
      Object.assign(effectiveLosses, losses);
    }
  });

  const snowLoss = getStateSnowLoss(lead?.property?.state || lead?.state);
  if (snowLoss !== null && snowLoss !== undefined && shouldApplyStateSnow(effectiveLosses.snow, forceStateSnow)) {
    effectiveLosses.snow = snowLoss;
  }

  return effectiveLosses;
};
